<template>
  <div style="height: 100px" class="pt-2">
    <template v-for="(v, i) in item.arr">
      <div :key="i" style="height: 100%" class="d-flex flex-column justify-space-between align-center">
        <div v-if="v.text" class="d-flex flex-column justify-center align-center">
          <div class="row-card-text">
            {{v.text}}
          </div>
          <down-two class="mt-2" v-if="item.arrow && i !== item.arr.length -1" theme="filled" size="24" fill="#2f81f6" :strokeWidth="3" strokeLinejoin="bevel"/>
        </div>
        <div v-if="v.image" class="row-card-image">
          <v-img :src="v.image" max-width="100px"></v-img>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import {DownTwo} from '@icon-park/vue'
export default {
  name: 'coreTechRow',
  components: {
    DownTwo
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
<style scoped>
.row-card-text {
  width: 200px;
  height: 52px;
  background-color: #2F81F6;
  color: white;
  line-height: 52px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.row-card-image {

  width: 200px;
  height: 52px;
  line-height: 52px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/home/prodCore/coreTechRow.vue